import { observable, action, runInAction, computed, toJS } from 'mobx';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';

import login_user_store from '@store/LoginUser/LoginUserStore';

import ChartType from './ChartTypeEnum';

class Store {
  /**
   * 个人信息
   */
  @observable
  myInfo = {};

  @computed
  get rate() {
    let result;
    if( isNaN(this.myInfo.radio * 100) ) {
      result = 0.00;
    } else {
      result = (Number(toJS(this.myInfo.radio))).mul(100).toFixed(2);
    }
    return result;
  }

  /**
   * 下线信息
   */
  @observable
  nextCountInfo = {};

  /**
   * 提现
   */
  @observable
  backMoney = [];

  /**
   * 今日活跃
   */
  @observable
  countActiveUser = [];

  /**
   * 今日新增会员
   */
  @observable
  countNewUser = [];

  /**
   * 今日投注
   */
  @observable
  orderMoney = [];

  /**
   * 今日充值
   */
  @observable
  payment = [];

  /**
   * (足球、篮球)串关返佣
   */
  @observable
  proxyAmount = [];

  /**
   * (足球、篮球)单关返佣
   */
  @observable
  proxyAmountdg = [];
  /**
   * 其他返佣
   */
  @observable
  proxyAmountqt = [];

    /**
   * 会员赠送
   */
     @observable
     membersPresent = [];
    @observable
    agentPresented = [];
    @observable
    offLinPayment = [];
    @observable
    onLinPayment = [];
    @observable
    transferChargeFree = [];
    @observable
    Arr = [];
    @observable
    Arr1 = [];
    @observable
    rechargeNum = [];
    @observable
    withdrawalNum = [];
    @observable
    hasLottery = [];
    @observable
    hasWinning = [];
    @observable
    notLottery = [];
  /**
   * 总返佣
   * @type {string}
   */
  @observable
    proxyCommissionData=0

  // 统计首页
  async fetchHomePageData( uid,type_time='6' ) {
    this.myInfo = {};
    this.nextCountInfo = {};
    // this.backMoney = [];
    // this.countActiveUser = [];
    // this.countNewUser = [];
    // this.orderMoney = [];
    // this.payment = [];

    // this.proxyAmount = [];
    // this.proxyAmountdg = [];
    // this.proxyAmountqt = [];


    let url = fetchUrl.pandect.homePage;
    let result = await service.fetchData({
      path: url,
      params: {
        uid: uid,
        flag:2,
        type_time:type_time
      }
    });
    if( result.success ) {
      // console.log('homePage: ', result.data);
      let Arr = []
      let Arr1 = []
      let result_data = result.data;
      runInAction(() => {
        for(let k in result_data.todayCountInfo){
          if(k == 'countNewUser' || k == 'countActiveUser' ||  k == 'rechargeNum' ||  k == 'withdrawalNum'  ){
            Arr1.push(result_data.todayCountInfo[k][0])
          // }else if(k != 'payment' && k != 'hasWinning'&& k != 'hasLottery' && k!="proxyAmount" && k!="proxyAmountdg" && k!="proxyAmountqt" ){
          }else if(k != 'payment' && k != 'hasWinning'&& k != 'hasLottery'){
            Arr.push(result_data.todayCountInfo[k][0])
          }
        }
        // Arr.push({
        //   data:result_data.nextCountInfo.nextBalance,
        //   name:'下线余额'
        // })
        // Arr.push({
        //   data:result_data.nextCountInfo.nextCaijin,
        //   name:'下线彩金'
        // })
        Arr1.push({
          data:result_data.nextCountInfo.nextProxyNum,
          name:'下线代理'
        })
        Arr1.push({
          data:result_data.nextCountInfo.nextUserNum,
          name:'下线会员'
        })

        // 计算足球、篮球（串关、单关)、其他佣金
        this.proxyAmount = result_data.todayCountInfo.proxyAmount;
        this.proxyAmountdg = result_data.todayCountInfo.proxyAmountdg;
        this.proxyAmountqt = result_data.todayCountInfo.proxyAmountqt;
        let proxyCommissionVal   = Number(this.proxyAmount[0]['data'])+Number(this.proxyAmountdg[0]['data'])+Number(this.proxyAmountqt[0]['data'])
        this.proxyCommissionData          = proxyCommissionVal.toFixed(2)
        // Arr.push({
        //   data:proxyCommission,
        //   name:'返佣'
        // })

        this.myInfo         = result_data.myInfo;
        this.nextCountInfo  = result_data.nextCountInfo;
        this.backMoney      = result_data.todayCountInfo.backMoney;
        this.countActiveUser= result_data.todayCountInfo.countActiveUser;
        this.countNewUser   = result_data.todayCountInfo.countNewUser;
        this.orderMoney     = result_data.todayCountInfo.orderMoney;
        this.payment        = result_data.todayCountInfo.payment;

        this.Arr    = Arr
        this.Arr1   = Arr1
        this.membersPresent     = result_data.todayCountInfo.membersPresent
        this.agentPresented     = result_data.todayCountInfo.agentPresented
        this.offLinPayment      = result_data.todayCountInfo.offLinPayment
        this.onLinPayment       = result_data.todayCountInfo.onLinPayment
        this.transferChargeFree = result_data.todayCountInfo.transferChargeFree
        this.rechargeNum        = result_data.todayCountInfo.rechargeNum
        this.withdrawalNum      = result_data.todayCountInfo.withdrawalNum
        this.hasLottery         = result_data.todayCountInfo.hasLottery
        this.hasWinning         = result_data.todayCountInfo.hasWinning
        this.notLottery         = result_data.todayCountInfo.notLottery
      })
    } else {

    }
  }

  /**
    * 今日统计（包含前6日）
    * @param type 类型 :
    *  1.充值统计       payment
    *  2.提现统计       backMoney
    *  3.投注金额统计    orderMoney
    *  4.返佣金额统计    proxyAmount
    *  5.新增会员统计    countNewUser
    *  6.活跃用户统计    countActiveUser
    * @param status 返回前台页面传1
   */
  async fetchTodayData( type, uid ) {
    let url = fetchUrl.pandect.countToday;
    let result = await service.fetchData({
      path: url,
      params: {
        uid: uid,
        flag: false,
        type: ChartType[ type ],
        status: 1
      }
    });
    if( result.success ) {
      // console.log('countToday: ', result.data);
      result.data.reverse();
      runInAction(() => {
        // this[type] = result.data;
      });
      return result;
    } else {

    }
  }
}

let my_summary_store = new Store();

export default my_summary_store;



// WEBPACK FOOTER //
// ./src/Store/Pandect/MySummary/MySummaryStore.js